import React, { Component } from 'react';
import './ConfirmData.css';
import logoblue from '../../image/logoblue.png'
import { Link } from 'react-router-dom';
import Navbar from '../Components/Navbar/Navbar'
import iconrightgreen from '../../image/iconrightgreen.svg'
import HandleRes from '../Components/HandleRes/HandleRes';
import  smartphone  from '../../image/smartphone.svg'

import axios from 'axios'
import { LinkAPI } from '../../API/API'
class CourierConfirmPhone extends Component {
    constructor(props) {
        super(props);
        this.state = {
            code: "",
            codeError: "",
            backEndError: "",
            res_sendcodedone:false,
            sendcode:false,
            res_done: false,
            errordatamessage: false,
            networkError: false,
            hasError: false,
        }
    }

    handleChange = event => {
        const isCheckbox = event.target.type === "checkbox";
        this.setState({
            [event.target.name]: isCheckbox
                ? event.target.checked
                : event.target.value
        });
    };

    validate = () => {
        let codeError = "";

        if (this.state.code.length !== 4 || isNaN(this.state.code)) {
            codeError = "write your code correct";
        }
        if (codeError) {
            this.setState({ codeError });
            return false;
        }
        return true;
    };
    resendcode=()=>{
    const Token =localStorage.getItem("userTokentConfirmData")
    axios.put(`${LinkAPI}/api/Courier/resendcode`,{},{
        headers:{
          Authorization:`${Token}`
        }
      }).then(res =>{
        this.setState({
            sendcode:true,
            res_sendcodedone:true,

           })
           setTimeout(() => {
             this.setState({
                 res_sendcodedone:false
             })
     }, 2000);
          }).catch(error=>{
            if (!error.response) {
                this.setState({
                    networkError: true
                })
            } else if (error.response.status === 402) {
                window.location.replace("/SignIn");
            } else if (error.response.data.message) {
                this.setState({
                    errordatamessage: true,
                    errordatamessagetext: error.response.data.message
                })
            } else {
                this.setState({
                    hasError: true,
                })
            }
          })
}
    handleSubmit = event => {
        event.preventDefault();
        const { code } = this.state
        const Token = localStorage.getItem("userTokentConfirmData")
        const isValid = this.validate();
        if (isValid) {
            
            axios.post(`${LinkAPI}/api/courier/compleatesignup`, { code: code }, {
                headers: {
                    Authorization: `${Token}`
                }
            }
            ).then(res => {
                this.setState({
                    res_done: true,
                    errordatamessage: false,
                    networkError: false,
                    hasError: false,
                })
                localStorage.setItem("userTokentConfirmData", "")

            }).catch(error => {
                if (!error.response) {
                    this.setState({
                        networkError: true,
                    })
                } else if (error.response.data.message) {
                    this.setState({
                        codeError: "",
                        errordatamessage: true,
                        errordatamessageText: error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
            })
        }
    };
    render() {
        document.title ="Kayn | Courier Confirm Phone"; 
        document.getElementsByTagName("META")[1].content="Kayn Courier Confirm Phone";
        document.documentElement.lang = 'en';
        return (
            <div className="AppEN ConfirmData">
                <Navbar />
                <div className='container'>
                    <div className="Sign  row">
                        <div className="logoform col-6 d-flex align-content-end flex-wrap">
                            <div className="col-12 text-center mt-auto p-2 bd-highlight"><Link to="/"><img className="logo" src={logoblue} alt="Kayn" /></Link>       </div>
                            <p className="fontsize2 text-center mb-5 col-12">Your package...your way</p>
                        </div>
                        <div className="col-md-6 form text-center p-lg-5 ">
                            {!this.state.res_done ?
                                <form className="mt-5 " onSubmit={this.handleSubmit}>
                                    <div className="py-3 ">
                                        <div className="mt-5  px-lg-5 nocounter">
                                        <img className="mt-2 warningimg" src={smartphone} alt="smartphone" /><br/> 
                                        <label className="text-muted fontsize9 py-3">Verify your phone number</label>
                                            <input type="number" className={"form-control badge-pill p-3 " + (this.state.codeError ? 'is-invalid' : '')} placeholder="Enter verification " name="code" onChange={this.handleChange} value={this.state.code} />
                                        </div>
                                        <div style={{ fontSize: 12, color: "red", }}>
                                            {this.state.codeError}
                                        </div>{(this.state.errordatamessage ?
                                            <div className="px-2" style={{ fontSize: 12, color: "red" }}>
                                                {this.state.errordatamessageText}
                                            </div> : '')}
                                                {this.state.sendcode?'':<p className="pointer fontsize11 text-muted py-1 my-1" onClick={this.resendcode}>Resend Code ?</p>}
                                    </div>

                                    <button type="submit" className="btn badge-pill p-2 pl-1 px-3 my-2 border shadow btn-primary" >confirm</button>
                                </form> :
                                <div className=" mx-auto  text-center textconfirm">
                                    <img className="mt-2 warningimg" src={iconrightgreen} alt="warning" />
                                    <p className="fontsize9 py-2">Your Phone is confirmed<br />Wait for a call from us</p>
                                </div>}
                        </div>
                    </div>
                </div>
                {(this.state.res_sendcodedone ? <HandleRes title="Massage has been sent" stylecss="alert-success" /> : '')}
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default CourierConfirmPhone;